<div [formGroup]="form"
     kalDialogContent>
    <kal-form-field>
        <kal-select formControlName="criterion" label="Critère">
            <kal-option *ngFor="let criterion of criteriaList" [value]="criterion">{{criterion.Libelle}}</kal-option>
        </kal-select>
    </kal-form-field>

    <kal-table #tableComponent [columns]="columns" [dataSource]="dataSource">
        <tr *kalHeaderRowDef kal-header-row></tr>

        <td *kalBodyCell="'label' let row" class="gup-U-bgColor--100">
            {{row.label}}
        </td>

        <td *kalBodyCell="tableComponent.defaultColumnName let row; let code = code">
            <kal-input [formControlName]="row[code]" type="number">
            </kal-input>
        </td>
    </kal-table>

    <kal-checkbox formControlName="replaceCurrentComputations"
                  kalTheme="switch"
                  label="Remplacer le calcul existant par la formule linéaire"></kal-checkbox>
</div>

<div kalDialogFooter>
    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">

            <kal-button (click)="submit()" [disabled]="form.invalid" kalTheme="primary">
                Valider
            </kal-button>

        </div>

        <div class="gup-O-list__item">

            <kal-button (click)="close()" kalTheme="secondary">
                Annuler
            </kal-button>

        </div>

    </div>

</div>



